const messages = {
  es: {
    translations: {
      selectLanguage: "Seleccione un idioma",
      allTicket: {
        form: {
          viewTags: "Todos los tickets",
        },
      },
      signup: {
        title: "Regístrate",
        toasts: {
          success: "¡Usuario creado con éxito! ¡Inicia sesión!!!",
          fail: "Error al crear usuario. Verifica los datos ingresados.",
        },
        form: {
          name: "Nombre de la empresa",
          cpfCnpj: "CPF/CNPJ",
          email: "Correo electrónico",
          phone: "Teléfono con (código de área)",
          plan: "Plan",
          password: "Contraseña",
        },
        formErrors: {
          cpfCnpj: {
            required: "El CPF/CNPJ es obligatorio",
            invalid: "CPF/CNPJ inválido",
          },
          name: {
            required: "El nombre de la empresa es obligatorio",
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
          },
          password: {
            short: "Contraseña demasiado corta",
            long: "Contraseña demasiado larga",
            required: "La contraseña es obligatoria",
          },
          phone: {
            required: "El teléfono es obligatorio",
          },
          plan: {
            required: "El plan es obligatorio",
          },
          email: {
            required: "El correo electrónico es obligatorio",
            invalid: "Correo electrónico inválido",
          },
        },
        buttons: {
          submit: "Registrar",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
        plan: {
          attendant: "Asistente",
          whatsapp: "WhatsApp",
          queues: "Colas",
        },
      },
      login: {
        title: "Iniciar sesión",
        form: {
          email: "Correo electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Entrar",
          register: "¡Regístrate ahora mismo!",
        },
      },
      resetPassword: {
        title: "Restablecer Contraseña",
        toasts: {
          emailSent: "¡Correo enviado con éxito!",
          emailNotFound: "¡Correo electrónico no encontrado!",
          passwordUpdated: "¡Contraseña actualizada con éxito!",
        },
        formErrors: {
          email: {
            required: "El correo electrónico es obligatorio",
            invalid: "Correo electrónico inválido",
          },
          newPassword: {
            required: "La nueva contraseña es obligatoria",
            matches:
              "Tu contraseña debe tener al menos 8 caracteres, incluyendo una letra mayúscula, una minúscula y un número.",
          },
          confirmPassword: {
            required: "La confirmación de contraseña es obligatoria",
            matches: "Las contraseñas no coinciden",
          },
        },
        form: {
          email: "Correo electrónico",
          verificationCode: "Código de verificación",
          newPassword: "Nueva contraseña",
          confirmPassword: "Confirmar nueva contraseña",
        },
        buttons: {
          submitEmail: "Enviar correo",
          submitPassword: "Restablecer contraseña",
          resendCode: "Reenviar código",
          resendCooldown: "Reenviar código en {{seconds}}s",
          back: "¿No tienes una cuenta? ¡Regístrate!",
        },
      },
      dashboard: {
        pipelineWon: "Total Ganado",
        pipelineLost: "Total Perdido",
        conversionRate: "Tasa de Conversión",
        toasts: {
          selectFilterError: "Parametrice el filtro",
          userChartError: "Error al obtener información de la conversación",
          dateChartError: "Error al obtener información de la conversación",
        },
        filters: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
          kanbanBoard: "Tablero Kanban",
          allKanbanBoards: "Todos los tableros",
          filterType: {
            title: "Tipo de Filtro",
            options: {
              perDate: "Filtro por Fecha",
              perPeriod: "Filtro por Período",
            },
            helper: "Seleccione el tipo de filtro deseado",
          },
        },
        performanceIndicators: {
          axisLeft: "Eje izquierdo",
          axisRight: "Eje derecho",
          none: "Ninguno",
          tickets: "Atenciones",
          wonCount: "Número de ventas",
          lostCount: "Número de pérdidas",
          wonValue: "Valor facturado",
          conversionRate: "Tasa de conversión",
          avgSupportTime: "Tiempo medio de atención",
          avgConversionTime: "Tiempo medio de conversión",
        },
        periodSelect: {
          title: "Período",
          options: {
            none: "Ninguno seleccionado",
            last3: "Últimos 3 días",
            last7: "Últimos 7 días",
            last15: "Últimos 15 días",
            last30: "Últimos 30 días",
            last60: "Últimos 60 días",
            last90: "Últimos 90 días",
          },
          helper: "Seleccione el período deseado",
        },
        counters: {
          inTalk: "En conversación",
          waiting: "En espera",
          finished: "Finalizados",
          newContacts: "Nuevos contactos",
          averageTalkTime: "T.M. de Conversación",
          averageWaitTime: "T.M. de Espera",
        },
        buttons: {
          filter: "Filtrar",
        },
        onlineTable: {
          ratingLabel: "1 - Insatisfecho, 2 - Satisfecho, 3 - Muy Satisfecho",
          name: "Nombre",
          ratings: "Evaluaciones",
          avgSupportTime: "T.M. de Atención",
          status: "Estado (Actual)",
        },
        charts: {
          user: {
            label: "Gráfico de Conversaciones",
            title: "Total de Conversaciones por Usuarios",
            start: "Inicio",
            end: "Fin",
            filter: "Filtrar",
          },
          date: {
            label: "Gráfico de Conversaciones",
            title: "Total",
            start: "Inicio",
            end: "Fin",
            filter: "Filtrar",
          },
        },
      },
      datePicker: { openDate: "Seleccionar fecha", openTime: "Seleccionar hora", time: "Hora", timeHint: "Introduce la hora en formato HH:mm", clear: "Limpiar", apply: "Aplicar" },
      plans: {
        newPlan: "Nuevo plan",
        editPlan: "Editar plan",
        registeredPlans: "Planes registrados",
        toasts: {
          errorList: "No fue posible cargar la lista de registros",
          errorOperation: "No fue posible realizar la operación",
          error: "No fue posible realizar la operación. Verifique si ya existe un plan con el mismo nombre o si los campos fueron completados correctamente",
          success: "¡Operación realizada con éxito!",
        },
        confirm: {
          title: "Eliminación de Registro",
          message: "¿Realmente desea eliminar el registro?",
        },
        form: {
          features: "Funciones",
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Colas",
          value: "Valor",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          kanban: "Kanban",
          integrations: "Integraciones",
          automation: "Automatización",
          campaigns: "Campañas",
          schedules: "Programaciones",
          enabled: "Habilitadas",
          disabled: "Deshabilitadas",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "$",
        },
      },
      activityAssignee: {
        title: "Responsable de la actividad",
        noAssignee: "Sin responsable",
        ticketOwner: "Propietario del ticket",
        allUsers: "Todos",
      },
      kanban: {
        toasts: {
          removed: "¡Etiqueta de Ticket Eliminada!",
          added: "¡Etiqueta de Ticket Agregada con Éxito!",
          columnReordered: "Etapa reordenada exitosamente",
          reorderError: "Error al reordenar etapa",
          permissionDenied: "Sin permiso para reordenar etapas",
          columnDeleted: "Etapa eliminada con éxito",
          archived: "¡Card archivado con éxito!",
          restored: "¡Card restaurado con éxito!",
          resolvedWon: "¡Marcado como Ganado!",
          resolvedLost: "¡Marcado como Perdido!",
        },
        outcome: {
          label: "Resultado",
          open: "Abierto",
          won: "Ganado",
          lost: "Perdido",
          save: "Guardar resultado",
        },
        archiveOnResolve: "Archivar al definir resultado",
        dropToWin: "Soltar aquí para marcar como Ganado",
        dropToLose: "Soltar aquí para marcar como Perdido",
        dropToArchive: "Soltar aquí para archivar",
        dropToRemoveFromStage: "Soltar aquí para eliminar de la etapa",
        dropToClose: "Soltar aquí para cerrar",
        dropToCloseAndRemove: "Soltar aquí para cerrar y eliminar",
        dropNoCardXAction: "Sin acción configurada en la X",
        drawer: {
          all: "Todos",
          won: "Ganados",
          lost: "Perdidos",
        },
        description: "Descripción",
        information: "Información",
        activity: "Comentarios y actividad",
        noActivity: "Sin actividad registrada",
        board: "Tablero",
        comment: {
          placeholder: "Escribe un comentario",
        },
        column: {
          addTitle: "Nueva Etapa",
          deleteTitle: "Eliminar Etapa",
          deleteMessage: "¿Seguro que quieres eliminar esta etapa?",
          options: "Opciones de Etapa"
        },
        boardModal: {
          title: {
            create: "Nuevo Tablero",
            edit: "Editar Tablero"
          },
          name: "Nombre del Tablero",
          showCardCountCompact: "Cantidad de cards",
          showCardValueSumCompact: "Suma de valores",
          showCardCount: "Mostrar Recuento",
          showCardValueSum: "Mostrar Suma de Valores",
          isManualSorting: "Clasificación Manual"
        },
        addColumn: "+ Agregar nueva etapa",
        open: "Abierto",
        seeTicket: "Ver Ticket",
        selectBoard: "Seleccionar tablero",
        noBoards: "Ningún tablero disponible",
        createNew: "➕ Crear nuevo...",
        column: {
          addTitle: "Nueva etapa",
          deleteTitle: "Eliminar etapa",
          deleteMessage: "¿Seguro que desea eliminar esta etapa{{name}}?",
          delete: "Eliminar etapa",
          collapse: "Contraer etapa",
          expand: "Expandir etapa",
          addTicket: "Agregar ticket/tarjeta",
        },
        actions: {
          new: "Nuevo",
          edit: "Editar",
          delete: "Eliminar",
        },
        boardModal: {
          new: "Nuevo tablero",
          edit: "Editar tablero",
          name: "Nombre del tablero",
          cancel: "Cancelar",
          save: "Guardar",
          create: "Crear",
          showCardCountCompact: "Cantidad de cards",
          showCardValueSumCompact: "Suma de valores",
          showCardCount: "Recuento de cards",
          showCardValueSum: "Suma de valores de cards",
          isManualSorting: "Ordenación manual",
          prioritizeUnread: "No leídos",
          openTicketOnCardAdd: "Crear nuevo card con ticket abierto",
          showClosedTicketsInArchived: "Mostrar tickets cerrados en archivados",
          enableOutcomeTracking: "Modo CRM",
          showCardTags: "Etiquetas en los cards",
          showCardPhone: "Teléfono en los cards",
          showCardLastMessage: "Último mensaje en los cards",
          showCardValue: "Valor en los cards",
          deleteTitle: "Eliminar tablero",
          deleteMessage: "¿Desea realmente eliminar este tablero? Las etiquetas vinculadas dejarán de estar asociadas al kanban.",
          saved: "Tablero guardado con éxito.",
          deleted: "Tablero eliminado con éxito.",
          generalSettings: "General",
          displaySettings: "Exhibición",
          tickets: "Tickets",
          cards: "Cards",
          tags: "Etiquetas",
          phone: "Teléfono",
          lastMessage: "Último mensaje",
          value: "Valor",
          description: "Descripción",
        },
        archived: {
          title: "Archivados",
          empty: "Ningún elemento archivado",
          restore: "Restaurar",
          restoreSuccess: "¡Card restaurado con éxito!",
          ticketRestoreSuccess: "¡Ticket reabierto con éxito!",
          viewArchived: "Ver Archivados",
          delete: "Eliminar permanentemente",
          archivedAt: "Archivado en",
          archivedBy: "Archivado por",
          card: "Card",
          ticket: "Ticket",
          closedTicket: "Ticket cerrado",
          reopenTicket: "Reabrir ticket"
        },
      },
      invoices: {
        title: "Financiero",
        paid: "Pagado",
        open: "Pendiente",
        expired: "Vencido",
        details: "Detalles",
        value: "Valor",
        dueDate: "Fecha Venc.",
        status: "Estado",
        action: "Acción",
        PAY: "PAGAR",
        PAID: "PAGADO",
      },
      checkoutPage: {
        steps: {
          data: "Datos",
          customize: "Personalizar",
          review: "Revisar",
        },
        success: "¡Suscripción realizada con éxito!, esperando la realización del pago",
        closeToEnd: "¡Falta poco!",
        BACK: "VOLVER",
        PAY: "PAGAR",
        NEXT: "SIGUIENTE",
        review: {
          title: "Resumen de la suscripción",
          details: "Detalles del plan",
          users: "Usuarios",
          whatsapp: "Whatsapp",
          charges: "Cobro: Mensual",
          total: "Total",
        },
        form: {
          firstName: {
            label: "Nombre completo*",
            required: "El nombre completo es obligatorio",
          },
          lastName: {
            label: "Apellido*",
            required: "El apellido es obligatorio",
          },
          address1: {
            label: "Dirección*",
            required: "La dirección es obligatoria",
          },
          city: {
            label: "Ciudad*",
            required: "La ciudad es obligatoria",
          },
          state: {
            label: "Estado/Provincia*",
            required: "El estado/provincia es obligatorio",
          },
          zipcode: {
            label: "Código Postal*",
            required: "El código postal es obligatorio",
            invalid: "Formato de código postal inválido",
          },
          country: {
            label: "País*",
            required: "El país es obligatorio",
          },
          useAddressForPaymentDetails: {
            label: "Usar esta dirección para los detalles de pago",
          },
          invoiceId: {
            label: "Usar este ID de factura",
          },
          nameOnCard: {
            label: "Nombre en la tarjeta*",
            required: "El nombre en la tarjeta es obligatorio",
          },
          cardNumber: {
            label: "Número de tarjeta*",
            required: "El número de tarjeta es obligatorio",
            invalid: "Número de tarjeta inválido (ej: 4111111111111)",
          },
          expiryDate: {
            label: "Fecha de vencimiento*",
            required: "La fecha de vencimiento es obligatoria",
            invalid: "Fecha de vencimiento inválida"
          },
          cvv: {
            label: "CVV*",
            required: "El CVV es obligatorio",
            invalid: "CVV inválido (ej: 123)",
          },
        },
        pricing: {
          users: "Usuarios",
          connection: "Conexión",
          queues: "Colas",
          SELECT: "SELECCIONAR",
          month: "mes",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión realizado con éxito!",
        },
        token: "Token",
      },
      connections: {
        needsAttention: "requiere atención",
        title: "Conexiones",
        toasts: {
          deleted: "¡Conexión con WhatsApp eliminada con éxito!",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? Esta acción no puede ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "¿Está seguro? Necesitará leer el código QR nuevamente.",
        },
        buttons: {
          add: "Agregar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Intentar nuevamente",
          qrcode: "CÓDIGO QR",
          newQr: "Nuevo CÓDIGO QR",
          connecting: "Conectando",
        },
        providerType: {
          label: "Tipo de Conexión",
          baileys: "WhatsApp Web",
          cloudApi: "WhatsApp API Oficial",
          official: "API Oficial"
        },
        toolTips: {
          disconnected: {
            title: "Error al iniciar sesión de WhatsApp",
            content: "Asegúrese de que su teléfono esté conectado a internet e intente nuevamente, o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando lectura del código QR",
            content: "Haga clic en el botón 'CÓDIGO QR' y lea el código QR con su teléfono para iniciar la sesión",
          },
          connected: {
            title: "¡Conexión establecida!",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono",
            content: "Asegúrese de que su teléfono esté conectado a internet y WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última actualización",
          default: "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agregar WhatsApp",
          edit: "Editar WhatsApp",
        },
        formErrors: {
          name: {
            required: "El nombre es obligatorio",
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
          },
          cloudApiPhoneNumberId: {
            required: "Número de teléfono de la Cloud API es obligatorio",
          },
          cloudApiAccessToken: {
            required: "Token de acceso de la Cloud API es obligatorio",
          },
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario laboral",
        },
        form: {
          name: "Nombre",
          default: "Predeterminado",
          sendIdQueue: "Cola",
          timeSendQueue: "Redirigir a cola en X minutos",
          queueRedirection: "Redirección de Cola",
          outOfHoursMessage: "Mensaje fuera de horario",
          queueRedirectionDesc:
            "Seleccione una cola para redirigir los contactos que no tienen cola asignada",
          prompt: "Prompt",
          queue: "Cola de Transferencia",
          timeToTransfer: "Transferir después de x (minutos)",
          expiresTicket: "Cerrar chats abiertos después de x minutos",
          expiresInactiveMessage: "Mensaje de cierre por inactividad",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusión",
          integration: "Integración",
          initialTag: "Etiqueta inicial",
          noInitialTag: "Ninguna",
          providerType: "Tipo de Conexión",
          cloudApiPhoneNumberId: "Número de teléfono de la Cloud API",
          cloudApiAccessToken: "Token de acceso de la Cloud API",
          cloudApiBusinessAccountId: "Business Account ID",
          cloudApiPhoneNumberIdHelp: "Use el Phone Number ID de Meta (no el número).",
          cloudApiAccessTokenHelp: "El token se guarda y se oculta. Complete solo para actualizarlo.",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado con éxito.",
      },
      qrCodeModal: {
        title: "Utilice su WhatsApp:",
        steps: {
          one: "1 - Abra WhatsApp en su teléfono",
          two: {
            partOne: "2 - Toque en Más opciones en Android",
            partTwo: "o en Configuración",
            partThree: "en iPhone",
          },
          three:
            "3 - Toque en Dispositivos vinculados y luego en Vincular un dispositivo",
          four: "4 - Apunte su teléfono a esta pantalla para capturar el código QR",
        },
        waiting: "Esperando lectura del código QR",
      },
      qrCode: {
        message: "Lea el código QR para iniciar la sesión",
      },
      contacts: {
        noResults: "No se encontraron contactos",
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto eliminado con éxito!",
          deletedAll: "¡Todos los contactos eliminados con éxito!",
        },
        searchPlaceholder: "Buscar...",
        noContacts: "Ningún contacto registrado",
        confirmationModal: {
          deleteTitle: "Eliminar ",
          deleteAllTitle: "Eliminar Todos",
          importTitle: "Importar contactos",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Está seguro que desea eliminar este contacto? Todos los tickets relacionados se perderán.",
          deleteAllMessage:
            "¿Está seguro que desea eliminar todos los contactos? Todos los tickets relacionados se perderán.",
          importMessage: "¿Desea importar todos los contactos del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contactos",
          importShort: "Importar",
          exportShort: "Exportar",
          delete: "Eliminar Todos los Contactos",
          message: "Enviar mensaje",
          edit: "Editar",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Acciones",
        },
      },
      contactImportModal: {
        title: "Planilla de contactos",
        labels: {
          import: "Importar contactos",
          result: "resultados",
          added: "Agregados",
          savedContact: "Contacto guardado",
          errors: "Errores",
        },
        buttons: {
          download: "Descargar planilla modelo",
          import: "Importar contactos",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Lenguaje",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar el ticket",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración probada con éxito!",
          addSuccess: "Integración agregada con éxito.",
          editSuccess: "Integración editada con éxito.",
        },
      },
      sideMenu: {
        name: "Menú Lateral Inicial",
        note: "Si está habilitado, el menú lateral iniciará cerrado",
        options: {
          enabled: "Abierto",
          disabled: "Cerrado",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          model: "Modelo",
          max_tokens: "Máximo de palabras en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes en el Historial",
          voice: "Voz",
          voiceKey: "Clave API de voz",
          voiceRegion: "Región de voz",
          responseType: "Tipo de respuesta",
          responseTypeText: "Texto",
          responseTypeVoice: "Voz",
          elevenLabsKey: "Clave ElevenLabs",
          elevenLabsVoice: "Voz ElevenLabs",
        },
        formErrors: {
          name: {
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
            required: "El nombre es obligatorio",
          },
          prompt: {
            short: "Prompt demasiado corto",
            required: "Describa el entrenamiento para la Inteligencia Artificial",
          },
          model: {
            required: "Informe el modelo deseado para el Prompt",
          },
          maxWords: {
            required: "Informe el número máximo de tokens en la respuesta",
          },
          temperature: {
            required: "Informe la temperatura",
          },
          apikey: {
            required: "Informe la API Key",
          },
          queueId: {
            required: "Informe la cola",
          },
          maxMessages: {
            required: "Informe el número máximo de mensajes en el historial",
          },
        },
        success: "¡Prompt guardado con éxito!",
        setor: "Informe el sector",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Cola",
          max_tokens: "Máximo Palabras Respuesta",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? ¡Esta acción no puede ser revertida!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Datos del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de WhatsApp",
          email: "Email",
          extraName: "Nombre del campo",
          extraValue: "Valor",
          whatsapp: "Conexión Origen: ",
        },
        formErrors: {
          name: {
            required: "El nombre es obligatorio",
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
          },
          phone: {
            short: "Número demasiado corto",
            long: "Número demasiado largo",
          },
          email: {
            invalid: "Email inválido",
          },
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado con éxito.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          nameShort: "Nombre corto",
          nameLong: "Nombre largo",
          nameRequired: "El nombre es obligatorio",
          color: "Color",
          colorShort: "Color corto",
          colorLong: "Color largo",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusión",
          outOfHoursMessage: "Mensaje fuera de horario",
          ratingMessage: "Mensaje de evaluación",
          token: "Token",
          orderQueue: "Orden de la cola (Bot)",
          integrationId: "Integración",
          initialTag: "Etiqueta inicial",
          noInitialTag: "Ninguna",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        toasts: {
          success: "Cola guardada con éxito.",
          info: "Haga clic en guardar para registrar los cambios",
        },
        tabs: {
          queueData: "Datos de la cola",
          attendanceTime: "Horarios de Atención",
        },
      },
      avatarUpload: {
        title: "Cambiar foto de perfil",
        selectImage: "Seleccione una imagen para usar como avatar",
        chooseFile: "Elegir imagen",
        changeImage: "Elegir otra imagen",
        save: "Guardar",
        cancel: "Cancelar",
        success: "Avatar actualizado con éxito!",
        deleteSuccess: "Avatar eliminado con éxito!",
        deleteAvatar: "Eliminar avatar",
        errors: {
          fileTooLarge: "Archivo demasiado grande. Máximo 5MB.",
          invalidType: "Tipo de archivo inválido. Use JPEG, PNG, GIF o WebP.",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        changeAvatar: "Clic para cambiar la foto",
        form: {
          name: "Nombre",
          email: "Email",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión Predeterminada",
          allTicket: "Todos los tickets",
          allTicketEnabled: "Habilitado",
          allTicketDesabled: "Deshabilitado",
          viewPendingTickets: "Modo de visualización",
          viewPendingTicketsEnabled: "Habilitado",
          viewPendingTicketsDisabled: "Deshabilitado",
          companyQuickMessages: "Respuestas rápidas de la empresa",
          companyQuickMessagesEnabled: "Habilitado",
          companyQuickMessagesDisabled: "Deshabilitado",
          allowTagEdit: "Edición de Tags",
          allowTagEditEnabled: "Habilitado",
          allowTagEditDisabled: "Deshabilitado",
        },
        formErrors: {
          name: {
            required: "El nombre es obligatorio",
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
          },
          password: {
            short: "Contraseña demasiado corta",
            long: "Contraseña demasiado larga",
          },
          email: {
            required: "El email es obligatorio",
            invalid: "Email inválido",
          },
        },
        labels: {
          liberations: "Liberaciones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado con éxito.",
      },
      scheduleModal: {
        title: {
          add: "Nueva Programación",
          edit: "Editar Programación",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha de Programación",
          sentAt: "Fecha de Envío",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar Programación",
          deleteMessage: "¿Está seguro que desea eliminar esta programación?",
        },
        success: "Programación guardada con éxito.",
      },
      tagModal: {
        title: {
          add: "Nueva Etiqueta",
          edit: "Editar Etiqueta",
        },
        form: {
          name: "Nombre",
          color: "Color",
          board: "Tablero de Kanban",
          noBoard: "Sin tablero",
          showClosedTickets: "Incluir tickets finalizados en esta etapa del Kanban",
          showClosedTicketsDisabledTooltip: "Este tablero usa Modo CRM. Los tickets finalizados salen de la etapa y aparecen en las pestañas Ganados o Perdidos.",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Etiqueta guardada con éxito.",
      },
      chat: {
        toasts: {
          fillTitle: "Por favor, complete el título de la conversación.",
          fillUser: "Por favor, seleccione al menos un usuario.",
        },
        modal: {
          title: "Conversación",
          titleField: "Título",
        },
        confirm: {
          title: "Eliminar Conversación",
          message: "Esta acción no puede ser revertida, ¿confirmar?",
        },
        chats: "Chats",
        messages: "Mensajes",
        noTicketMessage: "Seleccione un ticket para comenzar a chatear.",
        buttons: {
          close: "Cerrar",
          save: "Guardar",
          new: "Nueva",
          newChat: "Nuevo",
        },
      },
      drafts: {
        label: "Borrador",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTRE Y SUELTE ARCHIVOS EN EL CAMPO DE ABAJO",
          titleFileList: "Lista de archivo(s)",
        },
        toasts: {
          imageTooLarge: "Las imágenes pueden tener hasta {{limit}}MB.",
          videoTooLarge: "Los videos pueden tener hasta {{limit}}MB.",
          audioTooLarge: "Los audios pueden tener hasta {{limit}}MB.",
          documentTooLarge: "Los documentos pueden tener hasta {{limit}}MB.",
          genericTooLarge: "El archivo supera el límite permitido.",
          fileTooLarge: "El archivo supera el límite permitido.",
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Colas",
      },
      tickets: {
        toasts: {
          deleted: "La atención que estabas atendiendo fue eliminada.",
          unauthorized: "Acceso no permitido",
        },
        filters: {
          user: "Filtrar por usuarios",
          tags: "Filtrar por etiquetas",
          userPlaceholder: "Usuarios",
          tagsPlaceholder: "Etiquetas",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Abiertos" },
          closed: { title: "Resueltos" },
          search: { title: "Búsqueda" },
        },
        search: {
          placeholder: "Buscar atención y mensajes",
          sections: {
            tickets: "Tickets",
            messages: "Mensajes",
          },
          mediaChips: {
            photos: "Fotos",
            videos: "Videos",
            links: "Enlaces",
            documents: "Documentos",
          },
        },
        buttons: {
          showAll: "Todos",
          unreadFirst: "No leídos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a cola",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionLabel: "Transferir a conexión",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "Ningún usuario encontrado con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "En espera",
        assignedHeader: "En atención",
        noTicketsTitle: "¡Nada aquí!",
        noTicketsMessage:
          "Ninguna atención encontrada con ese estado o término buscado",
        buttons: {
          accept: "Aceptar",
          closed: "Finalizar",
          reopen: "Reabrir",
        },
      },
      ticketsListItem: {
        tooltip: {
          chatbot: "Chatbot",
          peek: "Espiar Conversación",
        },
        noQueue: "Sin cola",
      },
      ticketAdvanced: {
        selectTicket: "Seleccionar Ticket",
        ticketNav: "Ticket",
        attendanceNav: "Atenciones",
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escriba para buscar el contacto",
        add: "Conversar",
        searchQueueError:
          "Ocurrió un error inesperado al intentar buscar las colas",
        noQueue: "Sin cola",
        selectQueue: "Seleccione una cola",
        selectConection: "Seleccione una conexión",
        defaultConnection: "Conexión predeterminada",
        ticketReopened: "Ticket reabierto con éxito",
        contactNameLabel: "Nombre del contacto",
        contactNumberLabel: "Teléfono",
        contactNameRequired: "Ingrese el nombre del contacto",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      ticket: {
        noQueue: "Sin cola",
        unknownUser: "Usuario desconocido",
      },
      locationPreview: {
        button: "Visualizar",
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Atenciones",
          quickMessages: "Respuestas Rápidas",
          tasks: "Tareas",
          contacts: "Contactos",
          queues: "Colas & Chatbot",
          tags: "Etiquetas",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuraciones",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Actividades",
          campaigns: "Disparadores",
          flows: "Flowbuilder",
          annoucements: "Informativos",
          chats: "Chat Interno",
          management: "Gestión",
          financeiro: "Financiero",
          files: "Lista de archivos",
          prompts: "Open.AI",
          queueIntegration: "Integraciones",
        },
        appBar: {
          refresh: "Recargar página",
          notRegister: "Sin notificaciones",
          language: "Idioma",
          darkMode: "Modo Oscuro",
          lightMode: "Modo Claro",
          greeting: {
            hello: "Hola",
            welcome: "Bienvenido a",
            active: "Activo hasta",
          },
          user: {
            profile: "Perfil",
            logout: "Salir",
          },
          internalComms: {
            title: "Comunicación Interna",
            chatTab: "Chat Interno",
            mentionsTab: "Menciones",
            noMentions: "Sin menciones",
            markAllRead: "Marcar todas como leídas",
          },
          mentions: {
            title: "Menciones",
          },
          activities: {
            title: "Recordatorios",
            empty: "No hay recordatorios para las próximas 24h",
            viewAll: "Ver todas las actividades",
          },
        },
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Lenguaje",
          lastUpdate: "Última actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Está seguro? ¡Esta acción no puede ser revertida! y será eliminada de las colas y conexiones vinculadas",
        },
      },
      files: {
        title: "Lista de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "¡Lista eliminada con éxito!",
          deletedAll: "¡Todas las listas fueron eliminadas con éxito!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Eliminar Todos",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todos",
          deleteMessage: "¿Está seguro que desea eliminar esta lista?",
          deleteAllMessage: "¿Está seguro que desea eliminar todas las listas?",
        },
      },
      messagesAPI: {
        title: "API",
        labels: {
          doc: "Documentación para envío de mensajes",
          method: "Métodos de Envío",
          textMessage: "Mensaje de Texto",
          mediaMessage: "Mensaje Multimedia",
          instructions: "Instrucciones",
          observations: "Observaciones importantes",
          before1: "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes.",
          before2: "Para realizar el registro acceda al menú 'Conexiones', haga clic en el botón editar de la conexión e inserte el token en el campo correspondiente.",
          numberDescription: "El número para envío no debe tener máscara o caracteres especiales y debe estar compuesto por:",
          countryCode: "Código del País",
          number: "Número",
          textMessage2: "1. Mensajes de Texto",
          textMessageInstructions: "A continuación la lista de información necesaria para enviar mensajes de texto:",
          method2: "Método",
          e: "y",
          tests: "Prueba de Envío",
          mediaMessage2: "2. Mensajes Multimedia",
        },
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        toasts: {
          unauthorized: "¡Esta empresa no tiene permiso para acceder a esta página! Le estamos redirigiendo.",
          success: "¡Mensaje enviado con éxito!",
        },
        buttons: {
          send: "Enviar",
        },
      },
      notifications: {
        noTickets: "Ninguna notificación.",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sin adjunto",
        confirmationModal: {
          deleteTitle: "Eliminación",
          deleteMessage: "¡Esta acción es irreversible! ¿Desea continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "¡Atajo agregado con éxito!",
          deleted: "¡Atajo eliminado con éxito!",
        },
        dialog: {
          title: "Mensaje Rápido",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          add: "Agregar",
          edit: "Editar",
          availableForAll: "Disponible para todos",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Estado",
        },
        badges: {
          global: "Todos",
          personal: "Usuario",
        },
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          greeting: "Saludo",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
        },
      },
      contactLists: {
        title: "Listas de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lista",
        },
        dialog: {
          name: "Nombre",
          nameShort: "Nombre corto",
          nameLong: "Nombre largo",
          nameRequired: "El nombre es obligatorio",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no puede ser revertida.",
        },
        toasts: {
          deleted: "Registro eliminado",
          success: "Operación realizada con éxito",
        },
        noListsFound: "No se encontraron listas",
        noListsCreated: "No se crearon listas de contactos",
        tryOtherTerms: "Intente buscar con otros términos",
        clickToCreate: "Haga clic en el botón de arriba para crear su primera lista",
      },
      campaigns: {
        title: "Disparadores",
        searchPlaceholder: "Buscar...",
        report: {
          title: "Informe de",
          title2: "Campaña",
          of: "de",
          validContacts: "Contactos válidos",
          delivered: "Entregados",
          connection: "Conexión",
          contactList: "Lista de Contactos",
          schedule: "Programación",
          conclusion: "Conclusión",
        },
        config: {
          interval: "Intervalos",
          primaryIntervalTitle: "Intervalo aleatorio primario entre mensajes",
          secondaryIntervalTitle: "Intervalo aleatorio secundario entre mensajes",
          randomInterval: "Intervalo Aleatorio de Envío",
          biggerInterval: "Intervalo Mayor Después de",
          greaterInterval: "Intervalo de Envío Mayor",
          intervalMinLabel: "Intervalo de envío (menor)",
          intervalMaxLabel: "Intervalo de envío (mayor)",
          intervalRangeError: "El intervalo máximo debe ser mayor o igual al mínimo",
          noInterval: "Sin Intervalo",
          second: "segundo",
          seconds: "segundos",
          notDefined: "No definido",
          addVariable: "Agregar Variable",
          save: "Guardar Configuración",
          shortcut: "Atajo",
          content: "Contenido",
          close: "Cerrar",
          add: "Agregar",
        },
        buttons: {
          add: "Nuevo Disparador",
          contactLists: "Listas de Contactos",
        },
        status: {
          inactive: "Inactiva",
          programmed: "Programada",
          inProgress: "En progreso",
          canceled: "Cancelada",
          finished: "Finalizada",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Lista de Contactos",
          status: "Estado",
          scheduledAt: "Programación",
          completedAt: "Completada",
          confirmation: "Confirmación",
          actions: "Acciones",
          notDefined: "No definida",
          notDefined2: "No definido",
          notScheduled: "Sin programación",
          notConcluded: "No concluida",
          stopCampaign: "Detener Campaña",
          startCampaign: "Iniciar campaña",
          pauseCampaign: "Pausar campaña",
          resetCampaign: "Reiniciar campaña",
        },
        dialog: {
          new: "Nuevo Disparador",
          update: "Editar Disparador",
          readonly: "Solo Lectura",
          form: {
            name: "Nombre",
            nameShort: "Nombre corto",
            nameLong: "Nombre largo",
            helper: "Utilice variables como {nombre}, {primerNombre}, {numero}, {email} o defina variables personalizadas.",
            nameRequired: "El nombre es obligatorio",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            messagePlaceholder: "Contenido del mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programación",
            confirmation: "Confirmación",
            contactList: "Lista de Contactos",
            tagList: "Etiqueta de inclusión",
            tagInclude: "Etiqueta de inclusión",
            tagExclude: "Etiqueta de exclusión",
            fileList: "Lista de Archivos",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            start: "Iniciar Envíos",
            pause: "Pausar Envíos",
            reset: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no puede ser revertida.",
        },
        toasts: {
          configSaved: "Configuración guardada",
          success: "Operación realizada con éxito",
          cancel: "Campaña cancelada",
          start: "Campaña iniciada",
          pause: "Campaña pausada",
          reset: "Campaña reiniciada desde cero",
          restart: "Campaña reiniciada",
          deleted: "Registro eliminado",
        },
        noResults: "No se encontraron resultados",
        noCampaigns: "Ninguna campaña creada",
        active: "Activo",
        inactive: "Desactivado",
        editTooltip: "Editar campaña",
        deleteTooltip: "Eliminar campaña",
      },
      subscription: {
        title: "Suscripción",
        validity: "Validez de la suscripción",
        activeUntil: "Activa hasta",
        expiredOn: "Venció el",
        noDueDate: "Sin fecha de vencimiento",
        chargeEmail: "Email de facturación",
        signNow: "¡Suscribirse ahora!",
      },
      announcements: {
        active: "Activo",
        inactive: "Inactivo",
        title: "Informativos",
        searchPlaceholder: "Buscar...",
        high: "Alta",
        medium: "Media",
        low: "Baja",
        buttons: {
          add: "Nuevo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones",
        },
        dialog: {
          edit: "Edición de Informativo",
          add: "Nuevo Informativo",
          update: "Editar Informativo",
          readonly: "Solo Lectura",
          form: {
            priority: "Prioridad",
            required: "Campo obligatorio",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no puede ser revertida.",
        },
        toasts: {
          success: "Operación realizada con éxito",
          deleted: "Registro eliminado",
          info: "¡Esta empresa no tiene permiso para acceder a esta página! Le estamos redirigiendo.",
        },
      },
      campaignsConfig: {
        title: "Configuración de Campañas",
      },
      queues: {
        noResults: "No se encontraron colas",
        title: "Colas & Chatbot",
        noQueues: "Ninguna cola registrada",
        table: {
          id: "ID",
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de bienvenida",
          actions: "Acciones",
          orderQueue: "Ordenación de la cola (bot)",
        },
        buttons: {
          add: "Agregar cola",
          edit: "Editar",
          delete: "Eliminar",
        },
        toasts: {
          success: "Cola eliminada con éxito.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? ¡Esta acción no puede ser revertida! Las atenciones de esta cola seguirán existiendo, pero no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Colas",
      },
      users: {
        title: "Usuarios",
        table: {
          id: "ID",
          name: "Nombre",
          email: "Email",
          profile: "Perfil",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario eliminado con éxito.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Todos los datos del usuario se perderán. Las atenciones abiertas de este usuario serán movidas a la cola.",
        },
      },
      tabletSearch: {
        open: "Buscar",
        clear: "Limpiar búsqueda",
        active: "Búsqueda activa",
        results: "resultados",
        moreActions: "Más acciones",
      },
      todolist: {
        input: "Nueva tarea",
        buttons: {
          add: "Agregar",
          save: "Guardar",
        },
      },
      helps: {
        title: "Centro de Ayuda",
      },
      schedules: {
        noResultsWithFilters: "Sin resultados con los filtros actuales",
        clearFilters: "Limpiar filtros",
        title: "Actividades",
        noResults: "No se encontraron actividades",
        noSchedules: "No hay actividades registradas",
        confirmationModal: {
          deleteTitle: "¿Está seguro que desea eliminar esta Actividad?",
          deleteMessage: "Esta acción no puede ser revertida.",
          deleteTaskTitle: "¿Está seguro que desea eliminar esta tarea?",
          deleteTaskMessage: "Esta acción no puede ser revertida.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha de Programación",
          sentAt: "Fecha de Envío",
          status: "Estado",
          actions: "Acciones",
        },
        messages: {
          date: "Fecha",
          time: "Hora",
          event: "Evento",
          allDay: "Todo el Día",
          week: "Semana",
          work_week: "Actividades",
          day: "Día",
          month: "Mes",
          previous: "Anterior",
          next: "Siguiente",
          yesterday: "Ayer",
          tomorrow: "Mañana",
          today: "Hoy",
          agenda: "Agenda",
          noEventsInRange: "No hay actividades en el período.",
          showMore: "más",
        },
        activityTypes: {
          call: "Llamada",
          meeting: "Reunión",
          message: "Mensaje",
          email: "Correo",
          visit: "Visita",
          activity: "Tarea",
        },
        buttons: {
          add: "Nueva Actividad",
          edit: "Editar",
          delete: "Eliminar",
        },
        filters: {
          allUsers: "Todos",
          allTypes: "Todas",
        },
        tooltips: {
          viewDescription: "Ver descripción",
        },
        activityTypes: {
          call: "Llamada",
          meeting: "Reunión",
          message: "Mensaje",
          email: "Correo",
          visit: "Visita",
          activity: "Tarea",
          confirmationModal: {
            deleteTitle: "Eliminar Tipo de Actividad",
            deleteMessage: "¿Estás seguro de que deseas eliminar este tipo de actividad?",
          },
          toasts: {
            created: "¡Tipo de actividad creado!",
            updated: "¡Tipo de actividad actualizado!",
            deleted: "¡Tipo de actividad eliminado!",
          },
        },
        statuses: {
          schedule: {
            sent: "Enviado",
            error: "Error",
            late: "Atrasado",
            soon: "Pronto",
            scheduled: "Programado",
          },
          task: {
            done: "Completada",
            late: "Atrasada",
            soon: "Pronto",
            pending: "Pendiente",
          },
        },
        activityModal: {
          title: "Nueva Actividad",
          editTitle: "Editar Actividad",
          editScheduleTitle: "Editar Programación",
          board: "Tablero",
          allBoards: "Todos",
          type: "Tipo",
          connection: "Conexión",
          contact: "Contacto",
          description: "Descripción",
          message: "Mensaje",
          when: "Fecha/Hora",
          attachment: "Adjuntar",
          cancel: "Cancelar",
          save: "Guardar",
        },
        views: {
          list: "Lista",
          calendar: "Calendario",
        },
        toasts: {
          deleted: "Actividad eliminada con éxito.",
          created: "Actividad creada con éxito.",
          ticketNotFound: "Actividad no creada porque el ticket no existe.",
        },
      },
      task: {
        title: "Editar tarea",
        form: {
          description: "Describe la actividad...",
          when: "¿Cuándo?",
        },
        toasts: {
          deleted: "Tarea eliminada con éxito.",
        },
        success: "¡Tarea guardada con éxito!",
        error: "Error al guardar la tarea!",
      },
      flowBuilderTransferencia: {
        title: "Configurar Transferencia de Conexión",
        save: "Guardar",
        cancel: "Cancelar",
        destination: "Destino de la Transferencia",
        destinationConnection: "Conexión de Destino",
        destinationQueue: "Cola de Destino (Opcional)",
        noQueue: "Sin Cola",
        options: "Opciones de Transferencia",
        sendMessages: "Enviar mensajes (\"Transfiriendo atención...\" y \"Atención transferida con éxito.\")",
        keepTags: "Mantener etiquetas existentes del ticket",
        infoTitle: "Cómo funciona:",
        infoLine1: "El ticket actual será finalizado en la conexión de origen",
        infoLine2: "Un nuevo ticket será creado/reabierto en la conexión de destino",
        infoLine3: "El contexto del flujo se mantendrá y continuará en el ticket de destino",
        infoLine4: "Los mensajes recopilados anteriormente serán preservados",
        selectConnection: "Seleccione una conexión de destino",
        connected: "Conectado",
        disconnected: "Desconectado",
      },
      flowBuilderMenuModal: {
        explanationMessage: "Mensaje de explicación del menú",
        addOption: "Añadir Opción",
        typeN: "Escribe {{number}}",
        typeOption: "Escribe la opción",
        optionsFormat: "Formato de opciones",
        formatDot: "1. Opción",
        formatDash: "1 - Opción",
        formatBrackets: "[1] Opción",
        formatEmoji: "1️⃣ Opción",
        titleAdd: "Añadir menú al flujo",
        titleEdit: "Editar menú",
        buttonAdd: "Añadir",
        buttonSave: "Guardar",
      },
      tags: {
        title: "Etiquetas",
        confirmationModal: {
          deleteTitle: "¿Está seguro que desea eliminar esta Etiqueta?",
          deleteMessage: "Esta acción no puede ser revertida.",
          deleteAllMessage: "¿Está seguro que desea eliminar todas las Etiquetas?",
          deleteAllTitle: "Eliminar Todas",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Registros Etiquetados",
          actions: "Acciones",
        },
        buttons: {
          delete: "Eliminar etiqueta",
          add: "Nueva Etiqueta",
          deleteAll: "Eliminar Todas",
        },
        toasts: {
          deletedAll: "¡Todas las Etiquetas eliminadas con éxito!",
          deleted: "Etiqueta eliminada con éxito.",
        },
        noResults: "No se encontraron resultados",
        noTags: "Ninguna etiqueta creada",
      },
      settings: {
        schedulesUpdated: "Horarios actualizados con éxito.",
        success: "Configuración guardada con éxito.",
        title: "Configuración",
        tabs: {
          services: "Servicios",
          options: "Opciones",
          schedules: "Horarios",
          companies: "Empresas",
          plans: "Planes",
          billing: "Facturación",
          helps: "Ayuda",
        },
        options: {
          toasts: {
            success: "Operación actualizada con éxito.",
            error: "No se pudo guardar la configuración.",
          },
          fields: {
            ratings: {
              title: "Evaluaciones",
              disabled: "Deshabilitadas",
              enabled: "Habilitadas",
            },
            expedientManager: {
              title: "Gestión de Horario Laboral",
              queue: "Cola",
              company: "Empresa",
            },
            ignoreMessages: {
              title: "Ignorar Mensajes de Grupos",
            },
            acceptCall: {
              title: "Aceptar Llamada",
              disabled: "No aceptar",
              enabled: "Aceptar",
            },
            chatbotType: {
              title: "Tipo Chatbot",
              text: "Texto",
            },
            language: {
              title: "Idioma",
            },
            sendGreetingAccepted: {
              title: "Enviar saludo al aceptar el ticket",
            },
            sendMsgTransfTicket: {
              title: "Enviar mensaje en transferencia",
            },
            sendGreetingMessageOneQueues: {
              title: "Enviar saludo cuando haya solo 1 cola",
            },
            disabled: "Deshabilitado",
            active: "Activo",
            enabled: "Habilitado",
          },
          updating: "Actualizando...",
          tabs: {
            integrations: "INTEGRACIONES",
          },
        },
        helps: {
          toasts: {
            errorList: "No fue posible cargar la lista de registros",
            errorOperation: "No fue posible realizar la operación",
            error: "No fue posible realizar la operación. Verifique si ya existe una ayuda con el mismo nombre o si los campos fueron completados correctamente",
            success: "¡Operación realizada con éxito!",
          },
          buttons: {
            clean: "Limpiar",
            delete: "Eliminar",
            save: "Guardar",
          },
          grid: {
            title: "Título",
            description: "Descripción",
            video: "Video",
          },
          confirmModal: {
            title: "Eliminación de Registro",
            confirm: "¿Desea realmente eliminar este registro?",
          },
        },
        company: {
          newCompany: "Nueva empresa",
          editCompany: "Editar empresa",
          subscriptionSection: "Plan y suscripción",
          planChange: {
                        financeUnavailable: "Asaas no está configurado para consultar cobros y suscripciones.",
                        financeLoadError: "No se pudieron consultar los datos financieros. Inténtalo de nuevo.",
                        retryFinance: "Intentar de nuevo",

            title: "Revisar cambio de plan", company: "Empresa", current: "Plan actual", target: "Nuevo plan",
            cycleValue: "Importe por ciclo", usage: "Uso actual y límites del nuevo plan",
            users: "Usuarios", connections: "Conexiones", queues: "Colas", blocked: "El uso actual supera el límite del nuevo plan:",
            featuresLost: "Funciones que dejarán de estar disponibles", back: "Volver", confirm: "Confirmar", applying: "Confirmando…",
            editCompany: "Editar empresa", separatePassword: "Guarde el cambio de contraseña por separado antes de cambiar el plan.",
            previewError: "No se pudo preparar la revisión. Verifique el plan y los datos de facturación de la empresa.",
            confirmError: "No se pudo confirmar el cambio. Revise los datos y vuelva a intentarlo.",
            rejected: "El cambio no se aplicó. Revise los datos antes de volver a intentarlo.",
            statusError: "No se pudo verificar el cambio. Vuelva a intentarlo o contacte con soporte antes de iniciar otro.",
            storageError: "No se pudo guardar el identificador del cambio en este navegador.",
                                    paidCycle: "Ciclo pagado: desde {{start}} hasta la renovación del {{end}}.",
                        nextCycle: "Próximo ciclo",
                        newCharge: "Nuevo cobro",
                        newCycleValue: "Ciclo completo del nuevo plan",
                        unusedCredit: "Crédito: {{count}} de {{total}} días sin usar",
                        amountDue: "Total a pagar",
                        paymentDue: "Vencimiento",
                        upgradeActivation: "Nuevo plan después del pago",
                        upgradeExplanation: "El cobro vence el día siguiente a la solicitud. El pago confirmado activa el nuevo plan e inicia un ciclo completo en esa fecha. El crédito queda fijado en esta solicitud; la cobertura pagada y el período de gracia habitual siguen vigentes durante la espera.",
                        downgradeActivation: "Cambio el {{date}}",
                        downgradeExplanation: "El plan actual continúa hasta el final del ciclo pagado. El nuevo plan se aplica al finalizar, tras verificar los límites. No hay crédito por esta reducción; el acceso del próximo ciclo depende del pago, con el período de gracia habitual.",
                        fullRenewal: "Las siguientes renovaciones tendrán el valor completo de {{value}} por ciclo.",
                        downgradeLimits: "Reduce el uso antes de la fecha efectiva. El cambio necesitará revisión si estos límites siguen excedidos:",
                        awaitingPayment: "Esperando pago",
                        scheduled: "Cambio programado para el {{date}}",
                        reviewRequired: "Revisión necesaria",
                        verifying: "Verificando solicitud",
                        lookupFailed: "No se pudo consultar la solicitud",
                        requestFor: "Cambio de plan de",
                        openCharge: "Abrir cobro",
                        pendingCharge: "Cobro de {{value}} con vencimiento el {{date}}.",
                        awaitingExplanation: "El plan actual continúa hasta confirmar el pago, respetando la cobertura pagada y el período de gracia habitual.",
                        scheduledExplanation: "El plan actual continúa hasta el {{date}}. El cambio y los límites se verificarán en esa fecha.",
                        assignedExplanation: "El plan {{plan}} ya se ha aplicado. El nuevo ciclo espera la confirmación del pago, con el período de gracia habitual.",
                        limitReview: "El uso supera los límites del nuevo plan. Reduce usuarios, conexiones o colas y verifica de nuevo. No se eliminaron recursos.",
                        reviewExplanation: "El cambio necesita revisión financiera. Revisa la situación antes de iniciar otra solicitud.",
                        otherAdministrator: "Otro administrador confirmó esta solicitud. Puedes consultar su estado; el sistema continúa procesándola.",
                        companyNumber: "Empresa {{id}}",
                        pendingOperation: "Esta empresa ya tiene un cambio de plan pendiente. Consulta su estado antes de iniciar otro.",
                        checkStatus: "Verificar y reanudar",
                        useCampaigns: "Campañas", useSchedules: "Horarios", useInternalChat: "Chat interno", useExternalApi: "API externa", useKanban: "Kanban", useOpenAi: "OpenAI", useAutomation: "Automatizaciones", useIntegrations: "Integraciones"
          },
          toasts: {
            errorList: "No fue posible cargar la lista de registros",
            errorOperation: "No fue posible realizar la operación",
            error: "No fue posible realizar la operación. Verifique si ya existe una empresa con el mismo nombre o si los campos fueron completados correctamente",
            success: "¡Operación realizada con éxito!",
          },
          confirmModal: {
            title: "Eliminación de Registro",
            confirm: "¿Desea realmente eliminar este registro?",
            message: "¿Está seguro que desea eliminar esta empresa?",
          },
          form: {
            cpfCnpj: "CPF/CNPJ",
            cpfCnpjRequired: "El CPF/CNPJ es obligatorio",
            cpfCnpjInvalid: "CPF/CNPJ inválido",
            name: "Nombre",
            email: "Email",
            phone: "Teléfono",
            plan: "Plan",
            status: "Estado",
            trial: "Prueba",
            active: "Activo",
            yes: "Sí",
            no: "No",
            campanhas: "Campañas",
            enabled: "Habilitadas",
            disabled: "Deshabilitadas",
            dueDate: "Fecha de vencimiento",
            recurrence: "Recurrencia",
            monthly: "Mensual",
            expire: "Vencimiento",
            createdAt: "Creada En",
          },
          buttons: {
            cancel: "Cancelar",
            clear: "Limpiar",
            delete: "Eliminar",
            expire: "+ Vencimiento",
            user: "Usuario",
            save: "Guardar",
          },
        },
        schedules: {
          form: {
            weekday: "Día de la Semana",
            initialHour: "Hora Inicial",
            finalHour: "Hora Final",
            save: "Guardar",
          },
        },
        settings: {
          userCreation: {
            name: "Creación de usuario",
            options: {
              enabled: "Activado",
              disabled: "Desactivado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Regresar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            download: "Descargar",
            options: "Opciones",
          },
        },
        today: "Hoy",
        yesterday: "Ayer",
        quotedMessageNotFound: "Mensaje citado no encontrado",
        goToQuotedMessage: "Ir al mensaje citado",
        audioSpeed: "Velocidad del audio: {{speed}}x",
        lostCall: "Llamada de voz/video perdida a las",
        deletedMessage: "Este mensaje fue borrado por el contacto",
        edited: "Editado",
        saudation: "¡Saluda a tu nuevo contacto!",
        internalNoteBy: "Nota por {{author}}",
        internalNoteAuthor: "Equipo",
        noteRemoved: "¡Nota eliminada con éxito!",
        transferNote: {
          viewTicket: "Ver ticket #{{id}}",
          viewPreviousTicket: "Ver ticket anterior (#{{id}})",
        },
        vcard: {
          startConversation: "Iniciar conversación",
          multipleContacts: "Esta tarjeta contiene {{count}} contactos. Elige uno para iniciar la conversación.",
          noPhoneFound: "No se encontró un número telefónico válido en esta tarjeta de contacto.",
          ticketCreated: "Ticket creado a partir de la tarjeta de contacto.",
          ticketCreatedMultiple: "Ticket creado para {{contact}}.",
          ticketAlreadyOpen: "Ya existe un ticket abierto para este contacto. Te llevamos hasta él.",
          missingUserOwner: "No fue posible identificar al responsable del ticket para continuar la conversación."
        },
        interactiveButtons: {
          title: "Mensaje con botones",
        },
        interactiveList: {
          title: "Mensaje con lista",
          viewOptions: "Ver opciones",
        },
      },
      messagesInput: {
        placeholderOpen: "Escribe un mensaje",
        placeholderClosed: "Reabre o acepta este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        sendMessage: "Enviar mensaje",
        sendFile: "Enviar archivo",
        attachMenu: {
          title: "Adjuntar",
          file: "Archivo",
          contact: "Contacto",
          signature: "Firma",
        },
        contactDialog: {
          title: "Enviar contacto",
          search: "Buscar contacto por nombre",
          empty: "No se encontraron contactos",
          cancel: "Cancelar",
          unknown: "Contacto sin nombre",
          missingNumber: "Este contacto no tiene un número válido.",
        },
        recordAudio: "Grabar audio",
        noteToggle: "Nota",
        placeholderNote: "Escribe una nota interna",
        placeholderEditing: "Edite el mensaje y presione Enter para guardar.",
        saveNote: "Guardar nota",
        noteSaved: "¡Nota guardada con éxito!",
        noteError: "No fue posible guardar la nota",
        ticketNotOpen: "Este ticket no está abierto. No es posible enviar mensajes.",
        clearReply: "Limpiar respuesta",
        cancelRecording: "Cancelar grabación",
        sendAudio: "Enviar audio",
        cancelUpload: "Cancelar envío",
        sendErrorPending: "No se pudo enviar ahora. El mensaje quedará como pendiente.",
        replyPreview: {
          location: "Ubicación",
          contact: "Contacto",
          contacts: "{{count}} contactos"
        },
        editingMode: "Editando mensaje",
        saveEdit: "Guardar edición",
        cancelEdit: "Cancelar edición",
      },
      contactDrawer: {
        header: "Datos del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      contactDocuments: {
        status: {
          pending: "Pendiente",
          signed: "Completado",
          rejected: "Rechazado",
        },
      },
      fileModal: {
        title: {
          add: "Agregar lista de archivos",
          edit: "Editar lista de archivos",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre de la lista de archivos",
          message: "Detalles de la lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de la opción",
        },
        formErrors: {
          name: {
            required: "El nombre es obligatorio",
            short: "Nombre muy corto",
          },
          message: {
            required: "El mensaje es obligatorio",
          },
        },
        success: "¡Lista de archivos guardada con éxito!",
      },
      ticketOptionsMenu: {
        schedule: "Programación",
        delete: "Eliminar",
        transfer: "Transferir",
        exportHistory: "Guardar historial",
        exportSuccess: "¡Historial exportado con éxito!",
        registerAppointment: "Observaciones del Contacto",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Ingrese aquí la información que desea registrar",
        },
        confirmationModal: {
          title: "Eliminar el ticket",
          titleFrom: "del contacto ",
          message: "¡Atención! Todos los mensajes relacionados al ticket se perderán.",
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Responder",
        edit: "Editar",
        react: "Reaccionar",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
        editModal: {
          title: "Editar mensaje",
          placeholder: "Escriba el nuevo mensaje...",
          save: "Guardar",
          cancel: "Cancelar",
        },
        editErrors: {
          windowExpired: "Tiempo límite para editar expirado (15 minutos)",
          mediaMessage: "Los mensajes con medios no se pueden editar",
          notFromMe: "Solo los mensajes enviados por usted pueden ser editados",
          emptyMessage: "El mensaje no puede estar vacío",
          genericError: "No se pudo editar el mensaje",
        },
      },
      backendErrors: {
        ERR_COMPANY_CPF_CNPJ_REQUIRED: "El CPF/CNPJ es obligatorio.",
        ERR_COMPANY_INVALID_CPF_CNPJ: "CPF/CNPJ inválido. Verifique el número.",
        ERR_COMPANY_CPF_CNPJ_REJECTED: "Asaas rechazó este CPF/CNPJ. Verifique el número e intente de nuevo.",
        ERR_COMPANY_CPF_CNPJ_SYNC_FAILED: "No se pudo actualizar el CPF/CNPJ en Asaas. Intente de nuevo.",
        ERR_PLAN_CHANGE_CUSTOMER_DOCUMENT_REQUIRED: "Informe el CPF/CNPJ de la empresa para continuar con el upgrade.",
        ERR_PLAN_CHANGE_PROVIDER_REJECTED: "Asaas rechazó el cobro y no se generó nada. Revise los datos de la empresa e intente de nuevo.",
        ERR_OPENAI_MODEL_UNSUPPORTED: "Modelo de IA desconocido. Seleccione GPT 6 Luna, GPT 6.1 Sol o GPT 6 Astra.",
        ERR_SUPPORT_BETA_EXTERNAL_ACTION_DISABLED: "Esta acción está deshabilitada en este entorno de prueba.",
        ERR_INTERNAL_SERVER_ERROR: "Ocurrió un error inesperado. Por favor, intente nuevamente más tarde",
        ERR_NO_OTHER_WHATSAPP: "Debe haber al menos un WhatsApp predeterminado.",
        ERR_NO_DEF_WAPP_FOUND: "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED: "Esta sesión de WhatsApp no fue inicializada. Verifique la página de conexiones.",
        ERR_CLOUD_API_CONNECT_FAILED: "Error al conectar con la API oficial de WhatsApp. Verifique las credenciales.",
        ERR_WAPP_CHECK_CONTACT: "No fue posible verificar el contacto de WhatsApp. Verifique la página de conexiones",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de WhatsApp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA: "No fue posible descargar el archivo multimedia de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Por favor, intente nuevamente.",
        ERR_USER_DONT_EXISTS: "Usuario no encontrado. Verifique el email proporcionado.",
        ERR_SENDING_WAPP_MSG: "Error al enviar mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No fue posible eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya existe un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor inicie sesión.",
        ERR_SESSION_REVOKED: "Su sesión se cerró porque hubo inicio de sesión en otro dispositivo.",
        ERR_NO_AUTH_TOKEN: "Sesión no encontrada. Por favor inicie sesión nuevamente.",
        ERR_INVALID_ACCESS_TOKEN: "Token de acceso inválido. Intentando renovar su sesión.",
        ERR_USER_CREATION_DISABLED: "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_KANBAN_EXECUTION_MODE_INVALID: "Elige un modo de ejecución válido en la acción Añadir al Kanban.",
				ERR_KANBAN_EXECUTION_MODE_MIXED: "Usa el mismo modo de ejecución en todas las acciones Añadir al Kanban de esta secuencia.",
				ERR_KANBAN_CARD_TITLE_TEMPLATE_INVALID: "La plantilla del nombre de la tarjeta contiene una variable o formato no válido.",
        ERR_KANBAN_CARD_TITLE_TOO_LONG: "El nombre resultante de la tarjeta supera el límite de 255 caracteres.",
        ERR_NO_PERMISSION: "No tiene permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró ningún WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG: "Error al buscar el mensaje en WhatsApp, tal vez sea muy antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED: "El mensaje de saludo es obligatorio cuando hay más de una cola.",
        ERR_FILE_TOO_LARGE: "El archivo supera el límite permitido.",
        ERR_MEDIA_IMAGE_TOO_LARGE: "Las imágenes pueden tener hasta {{limit}}MB.",
        ERR_MEDIA_VIDEO_TOO_LARGE: "Los videos pueden tener hasta {{limit}}MB.",
        ERR_MEDIA_AUDIO_TOO_LARGE: "Los audios pueden tener hasta {{limit}}MB.",
        ERR_MEDIA_DOCUMENT_TOO_LARGE: "Los documentos pueden tener hasta {{limit}}MB.",
        ERR_CAMPAIGN_MEDIA_REQUIRED: "Esta campaña requiere un archivo multimedia adjunto. Adjunta una imagen antes de iniciar.",
        ERR_INVALID_NUMBER_FORMAT: "Formato de número inválido. El número debe tener al menos 8 dígitos.",
        ERR_NOT_BRAZILIAN_NUMBER: "Número internacional inválido. No fue posible verificar este número en WhatsApp.",
        ERR_INVALID_DDD: "Código de área inválido. El código debe estar entre 11 y 99.",
        ERR_INVALID_WHATSAPP_NUMBER: "Número de WhatsApp inválido. Verifique si el número es correcto y tiene WhatsApp activo.",
        ERR_NO_QUEUE_ACCESS: "Sin permiso para acceder a la cola {{queueName}}",
        ERR_TICKET_ASSIGNED_OTHER_USER: "Ticket asignado a {{userName}}",
        ERR_PENDING_TICKET_READONLY: "Ticket en modo pendiente. No es posible enviar mensajes.",
        ERR_CLOSED_TICKET: "Este ticket está cerrado. No es posible enviar mensajes. Por favor, reabra el ticket primero.",
        ERR_TRANSFER_VIEW_TARGET_REQUIRED: "No fue posible identificar el ticket relacionado con esta transferencia.",
        ERR_TRANSFER_VIEW_INVALID_SOURCE: "Ticket de origen inválido para visualizar la transferencia.",
        ERR_TRANSFER_VIEW_INVALID_TARGET: "Ticket relacionado inválido para visualizar la transferencia.",
        ERR_TRANSFER_VIEW_SOURCE_NOT_FOUND: "No se encontró el ticket de origen de la transferencia.",
        ERR_TRANSFER_VIEW_TARGET_NOT_FOUND: "No se encontró el ticket relacionado con la transferencia.",
        ERR_TRANSFER_VIEW_FORBIDDEN: "No tiene permiso para ver el historial de este ticket transferido.",
      },
      documentModal: {
        title: "Enviar documento para firma",
        documentInfo: "Información del documento",
        documentTitleLabel: "Título del documento",
        signers: "Firmantes",
        signerLabel: "Firmante",
        signerNameLabel: "Nombre del firmante",
        emailLabel: "Correo electrónico",
        whatsappLabel: "WhatsApp",
        whatsappTooltipPrimary: "Ingrese el WhatsApp para enviar el enlace.",
        whatsappTooltipSecondary: "Ingrese el WhatsApp para enviar el enlace.",
        addSigner: "Agregar firmante",
        documentOptions: "Opciones del documento",
        orderLabel: "Orden",
        enabled: "Habilitado",
        disabled: "Deshabilitado",
        visibleSignatureLabel: "Firma visible",
        signatureAppearanceLabel: "Estilo de firma",
        signatureAppearanceDefault: "Predeterminado",
        sendMethodLabel: "Método de envío",
        sendMethodLink: "Enlace",
        sendMethodEmail: "Correo electrónico",
        sendMethodWhatsapp: "WhatsApp",
        footerLabel: "Marca electrónica",
        footerNone: "Sin marca",
        folderSection: "Archivo y Carpeta",
        folderTypeLabel: "Tipo de carpeta",
        folderLabel: "Carpeta",
        folderNone: "Predeterminada (Raíz)",
        folderEmpty: "No hay carpetas disponibles",
        newFolderLabel: "Nueva carpeta",
        folderTypeRegular: "Mis carpetas",
        folderTypeOrganization: "Carpetas de la organización",
        createFolderSuccess: "¡Carpeta creada con éxito!",
        createFolderError: "Error al crear carpeta",
        loadFolderError: "Error al cargar carpetas"
      },
    },
  },
};

export { messages };
